/*eslint-disable*/
import {mapState} from 'vuex';

const AVAILABLE_COURSES = [
    'mentalArithmetic', 
    'russianLanguage'
];

export default {
    computed: {
        canShowBattle () {
            return AVAILABLE_COURSES.includes(this.selectedCourse) || this.user.isSuperadmin || this.user.isManagerOrSupport;
        },
        ...mapState({
            user: state => state.auth.user,
            selectedCourse: state => state.trainer.course
        })
    }
}
